import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { UnlikeSupporterCommentMutation, UnlikeSupporterCommentMutationVariables } from './unlikeComment.graphql';
import { UnlikeSupporterComment } from './unlikeComment.graphql';

export type UnlikeCommentInput = UnlikeSupporterCommentMutationVariables;

export async function unlikeComment(
	{ gql: { fetch } }: UtilityContext,
	{ commentId }: UnlikeCommentInput,
): Promise<void> {
	const { data } = await fetch<UnlikeSupporterCommentMutation, UnlikeSupporterCommentMutationVariables>({
		query: UnlikeSupporterComment,
		variables: { commentId },
		rejectOnError: true,
	});

	if (!data.unlikePetitionSupporterComment.success)
		throw new Error(`Unable to unlike comment (${data.unlikePetitionSupporterComment.reason || 'unknown'})`);
}
